export const CONTACT_INFO = {
  wechat: 'Easy-Aussie',
  email: 'easyaussie.info@gmail.com',
} as const;

export function getSupportContactHtml(options?: {
  containerClassName?: string;
  itemClassName?: string;
  iconClassName?: string;
}): string {
  const containerClassName = options?.containerClassName || '';
  const itemClassName = options?.itemClassName || '';
  const iconClassName = options?.iconClassName || '';

  return `
        <div class="${containerClassName}">
            <div class="${itemClassName}"><i class="fab fa-weixin ${iconClassName}"></i>微信：${CONTACT_INFO.wechat}</div>
            <div class="${itemClassName}"><i class="fas fa-envelope ${iconClassName}"></i>邮箱：${CONTACT_INFO.email}</div>
        </div>
    `;
}
